import React, { Component, Fragment } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { withRouter } from 'react-router';

import { UNAPPLIED_STUDENTS_REPORT_FORM_NAME } from 'Common/FormEnum';
import { UnappliedStudentsReportFieldEnum as Fields } from 'Common/FieldEnum';
import { CheckboxField, SelectField } from 'Common/SemanticWrapper';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';

class UnappliedStudentsReportFormContainer extends Component {
  sortBy = [
    { value: 0, text: 'Alpha Only' },
    { value: 1, text: 'School / Alpha' },
    { value: 2, text: 'School / Teacher / Alpha' },
    { value: 3, text: 'School / Grade' },
    { value: 4, text: 'Grade / Alpha' },
    { value: 5, text: 'Student Status' },
  ];

  provisionType = [
    { value: 0, label: 'Both' },
    { value: 1, label: 'CEP/Provision 2 Only' },
    { value: 2, label: 'Traditional' },
  ];

  componentDidUpdate(prevProps) {
    const { ShowDirectCertifiedOnly } = this.props.formValues;
    if (ShowDirectCertifiedOnly === true) {
      this.props.formValues.HadApplicationFromPriorYear = true;
    }
  }
  render() {
    const { loading, grades } = this.props;
    const {
      ShowDirectCertifiedOnly,
      HadApplicationFromPriorYear,
      ShowPaid,
    } = this.props.formValues;
    return (
      <Fragment>
        <Form name={UNAPPLIED_STUDENTS_REPORT_FORM_NAME}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={4}>
                <Field
                  label={'Sort By'}
                  options={this.sortBy}
                  component={SelectField}
                  name={Fields.SortBy}
                  disabled={loading}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={4}>
                <Field
                  label={'Grade'}
                  options={grades}
                  component={SelectField}
                  name={Fields.Grade}
                  disabled={loading}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <ReduxFormButtonGroup
                  label={'Provision Type'}
                  formName={UNAPPLIED_STUDENTS_REPORT_FORM_NAME}
                  fieldName={Fields.ProvisionType}
                  options={this.provisionType}
                  disabled={loading}
                />
              </Grid.Column>
            </Grid.Row>
            <label>Status</label>
            <Grid.Row>
              <Grid.Column width={2}>
                <Grid.Row>
                  <Field
                    label={'Free'}
                    name={Fields.ShowFree}
                    component={CheckboxField}
                    disabled={loading}
                  />
                </Grid.Row>
                <Grid.Row>
                  <Field
                    label={'Reduced'}
                    name={Fields.ShowReduced}
                    component={CheckboxField}
                  />
                </Grid.Row>
                <Grid.Row>
                  <Field
                    label={'Paid'}
                    name={Fields.ShowPaid}
                    component={CheckboxField}
                    disabled={ShowDirectCertifiedOnly}
                  />
                </Grid.Row>
              </Grid.Column>
              <Grid.Column width={5}>
                <Grid.Row>
                  <Field
                    label={'Direct Certified Only'}
                    name={Fields.ShowDirectCertifiedOnly}
                    component={CheckboxField}
                    disabled={ShowPaid}
                  />
                </Grid.Row>
                <Grid.Row>
                  <Field
                    label={'Had Application From Prior Year'}
                    name={Fields.HadApplicationFromPriorYear}
                    component={CheckboxField}
                    checked={
                      HadApplicationFromPriorYear || ShowDirectCertifiedOnly
                    }
                    disabled={ShowDirectCertifiedOnly}
                  />
                </Grid.Row>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    formValues: getFormValues(UNAPPLIED_STUDENTS_REPORT_FORM_NAME)(state),
  };
};

const UnappliedStudentsReportForm = reduxForm({
  form: UNAPPLIED_STUDENTS_REPORT_FORM_NAME,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(withRouter(connect(mapStateToProps)(UnappliedStudentsReportFormContainer)));

export { UnappliedStudentsReportForm };



// WEBPACK FOOTER //
// ./src/pages/unappliedstudents/components/UnappliedStudentsReportForm.js